import React from 'react';

import {
    IconFile,
    IconVolumeFull,
    IconVolumeMute,
    IconFileWithSpeaker,
    IconFileWithSpeakerMute,
    IconQuestionCircle,
} from '..';

interface TrackStatusIconProps {
    audioDeleted: boolean;
    filename?: Maybe<string>;
    title?: Maybe<string>;
    width?: number;
}

/**
 * Shows the status of a track with regards to whether it has a statement, an audio file, or both.
 * @param input - see {@link TrackStatusIconProps}
 */
export const TrackStatusIcon = ({
    audioDeleted,
    filename,
    title,
    width = 30,
}: TrackStatusIconProps): JSX.Element => {
    let icon: JSX.Element = (
        <IconQuestionCircle fillColor="primary-500" width={24} />
    );

    if (filename && title) {
        if (audioDeleted) {
            icon = (
                <IconFileWithSpeakerMute fillColor="tertiary-400" width={30} />
            );
        } else {
            icon = <IconFileWithSpeaker fillColor="primary-500" width={30} />;
        }
    }

    if (filename && !title) {
        if (audioDeleted) {
            icon = <IconVolumeMute fillColor="tertiary-400" width={18} />;
        } else {
            icon = <IconVolumeFull fillColor="primary-500" width={18} />;
        }
    }

    if (title && !filename) {
        icon = <IconFile fillColor="primary-500" width={30} />;
    }

    return (
        <div
            className="flex items-center justify-center"
            style={{ width, height: width }}
        >
            {icon}
        </div>
    );
};
